import { chain } from 'fp-ts/lib/TaskEither';
import { flow, pipe } from 'fp-ts/lib/function';
import {
  addVersionForUpdate,
  createGetRequest,
  createPutRequest,
  decodeVersioned,
  fetchApi,
  jsonHeaders,
  setBody,
  Versioned,
} from '../../..';
import { detailCodec, formCodec } from '@/services/api/resources/issue/public';
import { IssueStatusType } from '@/ui/pages/issue/public/issueTypes';

const baseIssueUrl = '/v2/public';
const recordUrl = (hash: string, id: number): string => `${baseIssueUrl}/${hash}/issues/${id}`;

export const get = flow(
  recordUrl,
  jsonHeaders(createGetRequest),
  fetchApi,
  chain(decodeVersioned(detailCodec)),
);

export const update = (hash: string, id: number, issue: Versioned<IssueStatusType>) => pipe(
  recordUrl(hash, id),
  jsonHeaders(createPutRequest),
  addVersionForUpdate(issue.version),
  setBody(formCodec.encode(issue.data)),
  fetchApi,
);
